import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetOrgUsersQueryVariables = Types.Exact<{
  where: Types.Users_Bool_Exp;
  orderBy?: Types.InputMaybe<Array<Types.Users_Order_By> | Types.Users_Order_By>;
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
}>;


export type GetOrgUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, display_name: string, email?: string | null, phone?: string | null, avatar_url?: string | null, default_role: string, active: boolean, customer_id?: number | null, created_at: string, updated_at: string, customer?: { __typename?: 'customers', id: number, name?: string | null } | null, driver?: { __typename?: 'drivers', id: number, status: string, phone_type?: string | null } | null, users_usertocustomers: Array<{ __typename?: 'usertocustomers', customer_id: number, customer: { __typename?: 'customers', id: number, name?: string | null } }>, users_usertofeatures: Array<{ __typename?: 'usertofeatures', id: number, feature: { __typename?: 'features', id: number, name: string, label: string } }>, users_usertoroles: Array<{ __typename?: 'usertoroles', role_id: number, roletype: { __typename?: 'roletypes', name: string } }> }> };


export const GetOrgUsersDocument = gql`
    query GetOrgUsers($where: users_bool_exp!, $orderBy: [users_order_by!], $limit: Int!, $offset: Int!) {
  users(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    id
    display_name
    email
    phone
    avatar_url
    default_role
    active
    customer_id
    created_at
    updated_at
    customer {
      id
      name
    }
    driver {
      id
      status
      phone_type
    }
    users_usertocustomers {
      customer_id
      customer {
        id
        name
      }
    }
    users_usertofeatures {
      id
      feature {
        id
        name
        label
      }
    }
    users_usertoroles {
      role_id
      roletype {
        name
      }
    }
  }
}
    `;

/**
 * __useGetOrgUsersQuery__
 *
 * To run a query within a React component, call `useGetOrgUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetOrgUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOrgUsersQuery, GetOrgUsersQueryVariables> & ({ variables: GetOrgUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgUsersQuery, GetOrgUsersQueryVariables>(GetOrgUsersDocument, options);
      }
export function useGetOrgUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgUsersQuery, GetOrgUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgUsersQuery, GetOrgUsersQueryVariables>(GetOrgUsersDocument, options);
        }
// @ts-ignore
export function useGetOrgUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrgUsersQuery, GetOrgUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgUsersQuery, GetOrgUsersQueryVariables>;
export function useGetOrgUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgUsersQuery, GetOrgUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgUsersQuery | undefined, GetOrgUsersQueryVariables>;
export function useGetOrgUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgUsersQuery, GetOrgUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrgUsersQuery, GetOrgUsersQueryVariables>(GetOrgUsersDocument, options);
        }
export type GetOrgUsersQueryHookResult = ReturnType<typeof useGetOrgUsersQuery>;
export type GetOrgUsersLazyQueryHookResult = ReturnType<typeof useGetOrgUsersLazyQuery>;
export type GetOrgUsersSuspenseQueryHookResult = ReturnType<typeof useGetOrgUsersSuspenseQuery>;
export type GetOrgUsersQueryResult = Apollo.QueryResult<GetOrgUsersQuery, GetOrgUsersQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/getOrgUsers.query.gql}
 */
export async function getOrgUsers(
  variables: GetOrgUsersQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOrgUsersQuery['users']>
export async function getOrgUsers(
  variables: GetOrgUsersQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOrgUsersQuery>
export async function getOrgUsers(
  variables: GetOrgUsersQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOrgUsersQuery['users'] | GetOrgUsersQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOrgUsersQuery>(
    GetOrgUsersDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.users
}